<template>
	<div v-title title="物流信息" class="wl-d-page">
		<img class="top-bg" src="@/assets/images/order/bg_wl_d.png" />
		<div class="box">
			<div class="line-key-val">
				<span class="line-key">物流公司</span>
				<div class="flex1"></div>
				<span class="line-val">{{ deliveryCompany }}</span>
			</div>
			<div class="line-key-val">
				<span class="line-key">物流单号</span>
				<div class="flex1"></div>
				<span class="line-val">{{ deliverySn }}</span>
			</div>
		</div>
		<div class="box wl-list-box">
			<van-steps active-color="#00754A" direction="vertical" :active="0">
				<van-step v-for="item in trackList" :key="item.id">
					<div class="flex">
						<span style="font-size: 14px;">{{ item.statusDesc }}</span>
						<span class="flex1"></span>
					</div>
					<div style="margin: 3px 0;">{{ item.nodeTimeFmt }}</div>
					<div style="font-size: 12px;">
						{{ item.nodeContext }}
					</div>
				</van-step>
			</van-steps>
		</div>
		<div ref="maidian" td-event="2668024000,https://cloudmall.counton.com.cn/commbank-ip/#/wuliuDetail"></div>
	</div>
</template>

<script>
export default {
	name: "ShouHouLisr",
	data() {
		return {
			searchForm: {
				orderId: ''
			},
			detail: {},
			list: [],
			finished: false,
			loading: false,
			deliveryCompany: '',
			deliverySn: '',
			trackList: []

		};
	},
	components: {},
	watch: {},
	created() {
		this.index = this.$route.query.i || 0
		this.searchForm.orderId = this.$route.query.orderId
		this.getDetail()

		let self = this
		this.$nextTick(() => {
			self.$refs['maidian'].click()
		})
	},
	mounted() {
	},
	methods: {
		onClickLeft() {
			if (this.$route.query.fromPage === 'orderList') {
				this.$router.push({
					path: '/' + this.$route.query.fromPage,
					query: {
						status: this.$route.query.status,
					}
				})
			}
			else if (this.$route.query.fromPage === 'orderDetail') {
				this.$router.push({
					path: '/' + this.$route.query.fromPage,
					query: {
						status: this.$route.query.status,
						orderId: this.$route.query.orderId,
					}
				})
			}

		},

		getDetail() {
			let id = ''
			let url = ''
			if (this.$route.query.orderId) {
				id = this.$route.query.orderId
				url = 'order/detail/'
			} else if (!this.$route.query.orderId && this.$route.query.orderCode) {
				id = this.$route.query.orderCode
				url = 'order/detailByOrderNo/'
			}
			this.$get(url + id, {}).then((res) => {
				console.log(res)
				if (res.code === this.GLOBAL.SUCCESS) {
					this.detail = res.data


					if (this.detail.deliverySn) {
						this.queryTrackList()
					}

				} else {
					this.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#ee0a24'
					})
				}
			})
		},
		queryTrackList() {
			this.deliveryCompany = this.detail.deliveryCompany
			this.deliverySn = this.detail.deliverySn
			this.$get('order/trackList/' + this.detail.id, {}).then((res) => {
				console.log(res)
				if (res.code === this.GLOBAL.SUCCESS) {
					this.trackList = []
					this.trackList = res.data[this.index]
					this.trackList.forEach(item => {
						let d = new Date(item.nodeTime)
						item.nodeTimeFmt = this.$parseTime(d)
					})
				} else {
					this.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#ee0a24'
					})
				}
			})
		},
	}
}
</script>

<style scoped lang="less">
/deep/.van-step--vertical::after {
	border: none;
}

.wl-d-page {
	position: relative;
	background: #F7F7F7;
	height: 100vh;
	overflow: auto;

	.top-bg {
		width: 375px;
		height: 136px;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 0;
	}

	.flex {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;

		.flex1 {
			flex: 1;
		}
	}


	.box {
		box-sizing: border-box;
		margin: 10px auto;
		width: 355px;
		background: #FFFFFF;
		border-radius: 10px;
		padding: 12px;
		position: relative;


		.line-key-val {
			padding: 8px 0;
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: center;
			align-items: flex-start;
			min-height: 16px;

			.flex1 {
				flex: 1;
			}

			.line-key {
				height: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #666666;
				line-height: 16px;
			}


			.line-val {
				max-width: 200px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #333333;
				line-height: 16px;
				text-align: right;
			}


		}


	}

}
</style>



// WEBPACK FOOTER //
// src/view/order/wuliuDetail.vue